class AnnouncementRotator {
  constructor(root) {
    this.root = root;
    this.items = Array.from(root.querySelectorAll('[data-announcement-rotator-item]')).filter(
      (item) => item.querySelector('.announcement-bar__message') !== null
    );
    this.index = Math.max(
      0,
      this.items.findIndex((item) => item.classList.contains('is-active'))
    );
    this.interval = parseInt(root.getAttribute('data-rotate-interval'), 10) || 5000;
    this.timer = null;
    this.paused = false;
  }

  init() {
    if (this.items.length < 2) return;

    if (window.Shopify && window.Shopify.designMode) {
      this.root.classList.add('shopify-design-mode');
      return;
    }

    this.items.forEach((item, position) => {
      item.classList.toggle('is-active', position === this.index);
    });

    this.root.addEventListener('mouseenter', this.pause.bind(this));
    this.root.addEventListener('mouseleave', this.resume.bind(this));
    this.root.addEventListener('focusin', this.pause.bind(this));
    this.root.addEventListener('focusout', this.resume.bind(this));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    });

    this.start();
  }

  show(next) {
    this.items[this.index].classList.remove('is-active');
    this.index = (next + this.items.length) % this.items.length;
    this.items[this.index].classList.add('is-active');
  }

  start() {
    if (this.timer || this.paused) return;
    this.timer = window.setInterval(() => this.show(this.index + 1), this.interval);
  }

  stop() {
    if (!this.timer) return;
    window.clearInterval(this.timer);
    this.timer = null;
  }

  pause() {
    this.paused = true;
    this.stop();
  }

  resume() {
    this.paused = false;
    this.start();
  }
}

document.querySelectorAll('[data-announcement-rotator]').forEach((root) => {
  new AnnouncementRotator(root).init();
});
